




















import Vue from "vue";
import { formatCurrency } from "@/utility/Formatter";

export default Vue.extend({
    props: {
        currency: { type: String, required: true },
        value: { required: true },
        autoColor: { type: Boolean, default: false },
        color: { type: String },
        showAlertIf: { type: Boolean, default: false },
        alertMessage: { type: String },
    },
    computed: {
        style() {
            return this.autoColor ? (this.value >= 0 ? "color: green" : "color: red") : this.color != null && this.color.length > 0 ? "color:" + this.color : "";
        },
    },
    methods: {
        formatCurrency,
    },
});
